import { createSlice } from "@reduxjs/toolkit"



const initialState={
    
    currentPens:[],
    tempPen:'',
    loadingP:false,
}

const pensSlice=createSlice({
name:'pens',

initialState,
reducers:{
    loginStartP:(state)=>{
        state.loadingP=true

    },
    loginSuccessP:(state,{payload})=>{
        state.loadingP=false;
        state.currentPens=payload;
        

    },
    loginFailureP:(state)=>{


    },
    ToTempPen:(state,{payload})=>{
        state.tempPen=payload
    },
 
    logOutP:(state)=>{
        state.loadingP=false;
        state.currentPens=[];
        state.tempPen=''
    }
    

}
})
export const {ToTempPen,loginStartP,loginFailureP,loginSuccessP,logOutP}=pensSlice.actions

export default pensSlice.reducer